module.exports = "https://trybtryb-legacy.web.app/img/back.54e42879.svg";